import React, { useEffect } from 'react';
import {
    Box,
    Heading,
    Text,
    VStack,
    useToast,
} from '@chakra-ui/react';
import Navbar from '../../../components/Navbar';
import { FilterFuelConsumption } from '../components/FilterFuelConsumption';
import { FuelConsumptionTable } from '../components/FuelConsumptionTable';
import { useFuelConsumption } from '../hooks/useFuelConsumption';
import type { FuelConsumptionFilters } from '../types';

export const FuelConsumptionPage: React.FC = () => {
    const { records, summary, loading, error, filters, fetchData } = useFuelConsumption();
    const toast = useToast();

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (error) {
            toast({
                title: 'Error',
                description: error,
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }, [error, toast]);

    const handleFiltersChange = (newFilters: FuelConsumptionFilters) => {
        fetchData(newFilters);
    };

    return (
        <Box minH="100vh" bg="gray.50">
            <Navbar />

            <Box flex="1" p={{ base: 4, md: 6 }}>
                <VStack spacing={6} align="stretch">
                    <VStack align="start" spacing={1}>
                        <Heading size="lg" color="gray.700" mb={2}>
                            Pengeluaran Solar vs Lacak
                        </Heading>
                        <Text color="gray.600" fontSize="sm">
                            Perbandingan pengeluaran solar per unit (Odoo) dengan pengisian dan pemakaian dari Lacak
                        </Text>
                    </VStack>

                    <FilterFuelConsumption
                        onFiltersChange={handleFiltersChange}
                        isLoading={loading}
                    />

                    <FuelConsumptionTable
                        records={records}
                        summary={summary}
                        date={filters.date}
                        loading={loading}
                        error={error}
                    />
                </VStack>
            </Box>
        </Box>
    );
};
